import React from 'react';
import ReactApexChart from 'react-apexcharts';

import { DEFAULT_HEIGHT, DEFAULT_WIDTH } from './constants';
import type { StanLineChartProps } from './types';
import { useStanLineChartOptions } from './hooks/useStanLineChartOptions';
import styles from './StanLineChart.module.css';
import { cn } from '@/lib/utils/cn';
export const StanLineChart: React.FC<StanLineChartProps> = ({
    height = DEFAULT_HEIGHT,
    width = DEFAULT_WIDTH,
    className,
    label,
    num,
    ...rest
}) => {
    const { options, resolvedSeries, chartType } = useStanLineChartOptions({
        ...rest,
    });

    return (
        <div className={cn(styles.container, className)}>
            {label ? <div className={styles.label}>{label}</div> : null}
            {num ? <div className={styles.metric}>{num}</div> : null}
            <ReactApexChart
                className={styles.chart}
                type={chartType}
                options={options}
                series={resolvedSeries}
                height={height}
                width={width}
            />
        </div>
    );
};

export default StanLineChart;
